function scrollToTop(): void {
    window.scrollTo(0, 0)
}

export const scrollUtils = {
    scrollToTop
}
